module.exports = __webpack_public_path__ + "static/media/Guida.f40c47a0.png";